
import 'vue';
import 'vuex';

import 'axios';

import 'jquery';

import 'bootstrap';

import "font-awesome/css/font-awesome.css";
import 'bootstrap/dist/css/bootstrap.min.css';


import "debug";
import "./shared/logger";